import { render, staticRenderFns } from "./public-pop.vue?vue&type=template&id=5afe5848&scoped=true&"
import script from "./public-pop.vue?vue&type=script&lang=js&"
export * from "./public-pop.vue?vue&type=script&lang=js&"
import style0 from "./public-pop.vue?vue&type=style&index=0&id=5afe5848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe5848",
  null
  
)

export default component.exports